import type { ConversationRowResource } from "api/generated";
import type {
  ConversationRow,
  ConversationRowPillStatus,
} from "conversations/types";
import { parseSchoolDateTime } from "shared/utils";

/**
 * Maps one row of the Gesprekken endpoints — the classroom tabs and the teacher's own
 * overview return the same shape.
 *
 * `date` carries a Dutch wall-clock moment, so it is read through the school clock rather
 * than the browser's timezone — see `parseSchoolDateTime`, same as `conversationFromDto`.
 */
export const conversationRowFromDto = (
  dto: ConversationRowResource,
): ConversationRow => ({
  id: dto.id,
  kind: dto.kind,
  name: dto.name,
  date: parseSchoolDateTime(dto.date),
  endDate: parseSchoolDateTime(dto.end_date),
  conversationType: {
    id: dto.conversation_type.id,
    name: dto.conversation_type.name,
  },
  subjectShortage: dto.subject_shortage ?? null,
  student:
    dto.student === null
      ? null
      : {
          id: dto.student.id,
          name: dto.student.name,
          avatar: dto.student.avatar,
        },
  partner:
    dto.partner === null || dto.partner === undefined
      ? null
      : { name: dto.partner.name, avatar: dto.partner.avatar },
  teacherShortage: dto.teacher_shortage ?? null,
  studentsCount: dto.students_count ?? null,
  studentsPrepared: dto.students_prepared_count ?? null,
  // A union of the two status enums, which Scramble flattens to a string on this endpoint
  // because the row's kind decides which one it is.
  status: dto.status as ConversationRowPillStatus,
  inProgress: dto.in_progress,
  deleting: dto.deleting,
});
